import React from 'react'
import PropTypes from 'prop-types'
import { Margin, Link } from 'shared/components'
import { InWinImage } from 'routes/shared/components'
import { event } from 'routes/route.map'

import * as styles from './styles'

const TournamentLogoCellComponent = ({ value: { id, tournament } }) => (
  <Link theme="black" to={event.view(id)}>
    <div css={styles.container}>
      <Margin right={1}>
        {tournament?.logo ? (
          <InWinImage
            source={tournament.logo}
            alt={tournament.tournamentName}
            css={styles.logo}
          />
        ) : (
          <div css={styles.logoPlaceholder} title={tournament?.tournamentName} />
        )}
      </Margin>
    </div>
  </Link>
)

TournamentLogoCellComponent.propTypes = {
  value: PropTypes.shape(),
}

export default TournamentLogoCellComponent
